module.exports = __webpack_public_path__ + "media/images/icons/credit_card/jcb-0d16bbf2fac9ed6673c1a99592942fe1.svg";